export default __webpack_public_path__ + "static/Group 84-6a96af7bc8e935a8ce7f47641fc1a42f.jpg";